const trim = require('mn-utils/trim');
const {NETWORKS_NAMES} = require("../constants/networks");

module.exports = (code = '') => {
  let network = '';
  let coin = '';

  coin = code;
  network = NETWORKS_NAMES[code];

  if (code !== 'MATIC' && (!network && !code.includes('_'))) return code;

  if (!network) {
    code = trim(code);

    const splitedCode = code.split('_');
    const networkKey = splitedCode[0];

    network = NETWORKS_NAMES[networkKey] || networkKey;
    coin = splitedCode[1];
  }

  return `${coin} (${network})`;
};
